import { LibraryDocument } from './LibraryBase';
import { Paged } from './Misc';
import { HighlightCategory, Operation, OperationRelated } from './Operation';

export enum QueryGroup {
  All = 'ALL',
  Claims = 'CL',
  Registration = 'RE',
  Eligibility = 'EL',
  Consultation = 'CO',
  CompReview = 'CR',
  Closed = 'CLOSED',
}

export interface MiciCaseItem {
  id: number;
  number: string;
  receiptDate: string;
  registerDate: string;
  status: string;
  stage: string;
  causes: string | null;
  relatedOperations: OperationRelated[];

  operationId: number;
  operationNumber: string;
  operationName: string;
  operationPhase: string;
  operationStage: string;
  operationSector: string;
  operationEsic: string;
  operationDccrc: string;
  operationEsrr: string;
  operationSpr: string;
  operationSRDate: string;
  operationDisbursementDate: string;
  operationDisbursed: number;
  closingDate: string;
  operationPrimaryMember: string;
  operationMembers: string;
  operationTeamLeader: string;
  caseClosure: string;
  regionCountry: string;
}

export interface MiciCase {
  id: number;
  number: string;
  receiptDate: string;
  registerDate: string;
  status: string;
  stage: string;
  country: string;
  operation: Operation;
  documents: MiciCaseDocument[];
  documentDraft: MiciCaseDocument;
  miciCauses: MiciCaseMiciCause[];
  phases: MiciPhase[];
}

export interface MiciCaseMiciCause {
  miciCaseId: number;
  miciCauseId: number;
  otherReason?: string;
}
export interface MiciCause {
  id: number;
  order: number;
  description: string;
  language: string;
}
export interface MiciCaseContext {
  miciCase: MiciCase;
  miciCauses: MiciCause[];
  canChangeMiciCauses: boolean;
}
export interface MiciCaseDocument extends LibraryDocument {
  stage: string;
}

export interface MiciCaseAttachment {
  id: number;
  documentName: string;
  documentLink: string;
}

export interface MiciCaseList extends Paged<MiciCaseItem> {
  highlightGroups: HighlightCategory[];
}

export interface MiciFilterBase {
  queryGroup: string;
}

export interface MiciFilter extends MiciFilterBase {
  // hideColumns: string[];
  pageNumber: number;
  pageSize: number;
  sortDescending: boolean;
  sortField: string;
  operationId?: number;
  hiddenColumns: string[];
}

export interface MiciContextType {
  data: MiciCaseContext;
  reload: () => void;
  loading: boolean;
}

export interface MiciPhase {
  code: string;
  status: string | null;
  milestones: MiciMilestone[];
}

export interface MiciMilestone {
  code: string;
  date: string | null;
  showInTimeline: boolean;
}
